import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesRepository } from 'common/repositories/index';

const _directiveDependencies = [];
const _controllerDependencies = [
    '$scope', '$state', '$timeout', '$filter', 'DeviceRestService',
    'Util',
];

class DeviceRenameController {

    constructor(
        $scope, $state, $timeout, $filter, DeviceRestService,
        Util,
    ) {

        this.$state = $state;

        $scope.form = {
            submitted: false,
            errorSubmission: false,
            waitingResponse: false,
            renameDevice: {},
        };

        $scope.localDevice = {
            name: $filter('deviceName')($scope.data),
            nameRegExp: /^[^:<>"+&%$#*^/\\]+$/i,
            isEditable: false,
            status: $scope.data && $scope.data.attributes.state,
            type: $scope.data && $scope.data.attributes.type,
        };

        const invalidNameHandler = () => {

            $scope.form.errorSubmission = true;
            $scope.form.waitingResponse = false;

            $timeout(() => {

                $scope.form.submitted = true;
                $scope.form.errorSubmission = false;

            }, 400);

            return false;

        };

        const updateDeviceHandler = () => {

            const devicePayload = {
                data: {
                    attributes: {
                        alias: $scope.localDevice.name,
                    },
                    type: 'devices',
                    id: $scope.data.id,
                },
            };

            DeviceRestService.update($scope.data.id, devicePayload)
                .then((response) => {

                    DevicesRepository.update(response.data.data);

                    Mixpanel.send('ConnectWeb Device Rename Click', {
                        Page: $state.current.name.indexOf('device-details') >= 0 ? 'Device Details' : 'My Devices',
                    });

                    $scope.form.submitted = false;
                    $scope.form.errorSubmission = false;
                    $scope.form.waitingResponse = false;
                    $scope.localDevice.isEditable = false;

                })
                .then(null, () => {

                    Alert.error(
                        {
                            message: 'cw.device.rename.error',
                            icon: {
                                cssClasses: `icon-${Util.deepFind($scope.data, 'attributes.type')}`,
                            },
                        },
                        {
                            message: {
                                deviceName: $filter('deviceName')($scope.data),
                            },
                        },
                    );


                    $scope.localDevice.name = $filter('deviceName')($scope.data);
                    $scope.localDevice.isEditable = false;
                    $scope.form.waitingResponse = false;

                });

        };

        $scope.rename = _.debounce(() => {

            $scope.form.submitted = false;
            $scope.form.waitingResponse = true;

            if (!$scope.form.renameDevice.$valid) {

                if ($scope.form.renameDevice.name.$error.required) {

                    $scope.localDevice.name = $filter('deviceName')($scope.data);
                    return true;

                }

                return invalidNameHandler();

            }

            return updateDeviceHandler();

        }, 300, true);

        $scope.localDevice.isEditable = false;
        $scope.devicesView = localStorage.getItem('DevicesView');

        const isOnDeviceDetails = (this.$state.current.name === 'root.dashboard.device-details');
        $scope.isOnListView = ($scope.devicesView === 'list' && !isOnDeviceDetails);

        $scope.toggleEditable = () => {

            if ($scope.devicesView === 'grid' || isOnDeviceDetails) {

                $scope.localDevice.isEditable = !$scope.localDevice.isEditable;

            }

        };

        // HACK: fixes a bug when we rename the device and change the state,
        // and are left with the old input in the model
        // until we change it again
        $scope.$watch('data', (newData, oldData) => {

            if (newData !== oldData) {

                $scope.localDevice.name = $filter('deviceName')(newData);

            }

        });

    }

}

class DeviceRenameDirective {

    constructor() {

        this.template = require('./device-rename.html');
        this.restrict = 'E';
        this.replace = true;
        this.scope = { data: '=' };
        this.link = ($scope, elem) => {

            const input = elem.find('#renameDevice');
            // whenever the edit button is clicked we focus on the input and select the entire text
            $scope.$watch('localDevice.isEditable', (newValue) => {

                if (newValue === true) {

                    input.focus();

                }

            });

        };

        _controllerDependencies.push((
            $scope, $state, $timeout, $filter,
            DeviceRestService, Util,
        ) =>
            new DeviceRenameController(
                $scope, $state, $timeout, $filter,
                DeviceRestService, Util,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'deviceRenameCtrl';

    }

}

_directiveDependencies.push(() => new DeviceRenameDirective());


angular.module('directives')
    .directive('deviceRename', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/device-rename/device-rename.js